import React, { useState, useEffect } from 'react';

import { Icon } from '../IconExporter';
import { Container } from './styles';

type CheckboxProps = {
  size?: number;
  disabled?: boolean;
  intermediate?: boolean;
  handleChange?: (isCheckedValue: boolean) => void;
  handleChangeCallback?: (isCheckedValue: boolean) => void;
  value?: boolean;
}

export const Checkbox = ({ value, size = 25, disabled = false, intermediate = false, handleChange, handleChangeCallback }: CheckboxProps) => {
  const [isChecked, setIsChecked] = useState(value);

  const handleClick = () => {
    setIsChecked(!isChecked);
    // TODO: Validar aonde esta sendo usado nos Projetos e remover
    handleChange && handleChange(!isChecked);
    handleChangeCallback && handleChangeCallback(!isChecked);
  }
  
  return <Container 
    size={size}
    isChecked={isChecked}
    onClick={handleClick}
    disabled={disabled}
    intermediate={intermediate}
  >
    {intermediate && <Icon name="parcial" color="#8C8B8B" />}
    {isChecked && !intermediate && <Icon name="verificado" color={intermediate ? '#8C8B8B' : '#fff'} />}
  </Container>
}